import React, { Fragment } from 'react';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { MDBMask, MDBView } from 'mdbreact';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">

        <Fragment >
          <MDBContainer fluid style={{ margin: "0", padding: "0", minHeight: "73.65vh" }}>

            <MDBView src={`https://mdbootstrap.com/img/Photos/Others/gradient3.png`} >
              <MDBMask className="d-flex justify-content-center align-items-center" overlay="blue-light">

                <MDBContainer>
                  <MDBRow>
                    <MDBCol md="12" className="mb-4 text-center">
                      <h1 className="display-3 mb-0 pt-md-5 pt-5  font-weight-bold" style={{ color: "black" }} >Sure <span className="font-weight-bold" style={{ color: "#005d9c" }}>Can </span> <span className="font-weight-bold" style={{ color: "#005d9c" }}>Pay </span></h1>
                      <h5 className="text-uppercase pt-md-5 pt-sm-2 pt-5 pb-md-5 pb-sm-3 pb-5 font-weight-bold">Payment Solutions</h5>
                      <h5>Comms Tester</h5>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>

              </MDBMask>
            </MDBView>





            <p style={{ height: "0px", display: "none", margin: "0" }}>1</p>


            <p style={{ height: "0px", display: "none", margin: "0" }}>2</p>

          </MDBContainer>
        </Fragment>
      </header>
    </div>
  );
}

export default App;
